import {
  JSON_MODAL_PAYLOAD_KIND,
  JSON_MODAL_PRIMARY_DOCUMENT_TITLE,
  type JsonModalDocument,
  type JsonModalPayload,
  type JsonModalResolvedDocument,
} from './types';

function mapToObject(aMap: Map<unknown, unknown>): Record<string, unknown> {
  const obj: Record<string, unknown> = Object.create(null);
  for (const [k, v] of aMap) {
    obj[String(k)] = v;
  }
  return obj;
}

function replacer(_key: string, value: unknown): unknown {
  if (value instanceof Map) {
    return mapToObject(value);
  }
  return value;
}

export function stringifyJsonValue(value: unknown): string {
  const serialized = JSON.stringify(value, replacer, 2);

  if (typeof serialized !== 'string') {
    throw new TypeError(`Unable to serialize value of type ${typeof value} to JSON`);
  }

  return serialized;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value != null;
}

function isJsonModalDocument(value: unknown): value is JsonModalDocument {
  return (
    isRecord(value) &&
    typeof value.id === 'string' &&
    value.id.length > 0 &&
    typeof value.title === 'string' &&
    value.title.length > 0
  );
}

export function isJsonModalPayload(value: unknown): value is JsonModalPayload {
  if (!isRecord(value) || value.kind !== JSON_MODAL_PAYLOAD_KIND) {
    return false;
  }

  return Array.isArray(value.documents) && value.documents.length > 0 && value.documents.every(isJsonModalDocument);
}

function resolveDocument(doc: JsonModalDocument): JsonModalResolvedDocument {
  const isEmpty = doc.value === undefined || doc.value === null;
  const content = isEmpty && doc.emptyMessage != null ? doc.emptyMessage : stringifyJsonValue(doc.value);

  return {
    id: doc.id,
    title: doc.title,
    content,
  };
}

export function resolveJsonModalDocuments(data: unknown): JsonModalResolvedDocument[] {
  if (isJsonModalPayload(data)) {
    return data.documents.map(resolveDocument);
  }

  return [{ id: 'json', title: JSON_MODAL_PRIMARY_DOCUMENT_TITLE, content: stringifyJsonValue(data) }];
}
